export function getParameterByName(url: string, name: string) {
  var qmark = url.indexOf("?");
  if (qmark <= 0) {
    return "";
  }
  var regex = new RegExp(
      "[\\?&]" +
        name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]") +
        "=([^&#]*)"
    ),
    results = regex.exec(url.substr(qmark));
  return results === null
    ? ""
    : decodeURIComponent(results[1].replace(/\+/g, " "));
}
